import tjCookie from '@/utils/tjCookie'
import api from '@/services/userTokenApi'
import { trackReportLog } from '@/business/report'
import urlHelper from '@lib/utils/urlHelper'

const tokenManager = {
  tempGet() {
    return tjCookie.getUserToken()
  },
  getUserIdFromUrl() {
    const params = ['userId', 'userID', 'userid']
    for (const param of params) {
      const id = urlHelper.queryString(param)
      if (id) { return id }
    }
    return null
  },
  get() {
    return new Promise((resolve) => {
      const userId = tjCookie.getUserId()
      const token = tjCookie.getUserToken()
      if (!userId || !token) {
        trackReportLog('USER_OR_TOKEN_EMPTY', { userId, token })
      }
      api
        .getUserToken()
        .then((data) => {
          trackReportLog('GET_USER_TOKEN_SUCCESS', { data })
          if (!data.userToken) {
            trackReportLog('GET_USER_TOKEN_EMPTY', { data })
          }
          resolve(data.userToken || token)
        })
        .catch(({ errorNo, errorMsg }) => {
          // this.$toast(errorMsg || 'Get_User_Token Error')
          trackReportLog('GET_USER_TOKEN_FAIL', { errorNo, errorMsg })
          resolve(token)
        })
    })
  },
  set(token, returnUrl = '') {
    const userId = this.getUserIdFromUrl() || tjCookie.getUserId()
    return new Promise((resolve) => {
      const params = { userId: userId, token, returnUrl }
      api
        .setUserToken(params)
        .then((data) => {
          trackReportLog('SET_USER_TOKEN_SUCCESS', { ...params, data })
          resolve()
        })
        .catch(({ errorNo, errorMsg }) => {
          // this.$toast(errorMsg || 'Set_User_Token Error')
          trackReportLog('SET_USER_TOKEN_FAIL', { ...params, errorNo, errorMsg })
          tjCookie.setUserToken(token)
          resolve()
        })
    })
  }
}

export default tokenManager
